import { WorkspaceTier } from "./local/Types";

// workspaces/status
// Only changed by functions.
export class WorkspaceStatus {
  static COL = 'status';
  id: string;
  tier: WorkspaceTier = 'FREE';
  filesMB: number = 0;
  screenRecordingsMB: number = 0;
  voiceRecordingsMB: number = 0;
  aiTrainingDocsMB: number = 0;
  lastUpdated: Date = new Date();
  trialStart?: Date;
  trialEnd?: Date;

  constructor(workspaceId: string) {
    this.id = workspaceId;
  }

  static getTotalMB(status: WorkspaceStatus | undefined): number {
    if (!status)
      return 0;
    return status.filesMB + status.screenRecordingsMB + status.voiceRecordingsMB + status.aiTrainingDocsMB;
  }

  // New Fields for Allocation Pool System
  totalStorageBytes: number = 0;   // Physical Usage (Bytes)
  totalAllocatedBytes: number = 0; // Logically Allocated to Members (Bytes)
}
